import React, { useState, useEffect } from 'react';

const TextfieldIcon = ({
	id,
	label,
	iconSrc,
	placeholder,
	isRequired = false,
	showAsterix = false,
	value,
	onChange,
}) => {
	const [inputValue, setInputValue] = useState(value || '');

	useEffect(() => {
		if (value !== undefined) {
			setInputValue(value);
		}
	}, [value]);

	const handleInputChange = (event) => {
		let newValue = event.target.value;
		setInputValue(newValue);

		if (onChange) {
			onChange(event);
		}
	};

	return (
		<div style={{ display: 'flex', flexDirection: 'column' }}>
			<label
				style={{
					fontSize: '14px',
					margin: '8px 0',
					color: '#4b5080',
					fontWeight: '500',
				}}>
				{label}
				{showAsterix && isRequired && (
					<span
						style={{
							color: inputValue ? '#4b5080' : '#ff0000',
							marginLeft: '4px',
						}}>
						{' '}
						*
					</span>
				)}
			</label>
			<div
				style={{
					display: 'flex',
					alignItems: 'center',
					border: '1px solid #ccc',
					borderRadius: '8px',
					padding: '12px',
				}}>
				{iconSrc && (
					<img
						src={iconSrc}
						alt=''
						style={{ width: '14px', height: '14px', marginRight: '8px' }}
					/>
				)}
				<input
					id={id}
					type='text'
					placeholder={placeholder}
					value={inputValue}
					onChange={handleInputChange}
					required={isRequired}
					style={{
						fontFamily: 'Satoshi, sans-serif',
						fontSize: '14px',
						border: 'none',
						outline: 'none',
						flex: 1,
					}}
				/>
			</div>
		</div>
	);
};

export default TextfieldIcon;
